import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import { updateBookData } from '../../../../../store/slices/bookSlice';
import { FEATURES } from '../../../../../constants/features';

const SpellcheckSection: React.FC = () => {
  const dispatch = useAppDispatch();
  const bookData = useAppSelector((state) => state.book.bookData);
  const [spellcheckConsent, setSpellcheckConsent] = useState(false);
  const spellcheckAdded = bookData.addons?.spellcheck || false;

  if (!FEATURES.SPELLCHECK) return null;

  const handleAddSpellcheck = () => {
    dispatch(updateBookData({ addons: { ...bookData.addons, spellcheck: true } }));
  };

  const handleRemoveSpellcheck = () => {
    dispatch(updateBookData({ addons: { ...bookData.addons, spellcheck: false } }));
  };

  return (
    <div className="border-t border-gray-200 pt-6 mt-6">
      <div className="bg-orange-50 border-l-4 border-orange-400 p-4 rounded">
        <p className="text-orange-700 text-sm font-medium mb-2">
          › Do you want to spellcheck your book?
        </p>
        <p className="text-gray-700 text-sm mb-3">
          Spellcheck will be performed on your book to iron out all the spelling mistakes & grammatical errors. You will be charged 8x for this service package
        </p>
        <p className="text-gray-500 text-xs mb-3">
          We need your consent for this step as we will be uploading your content to an AI agent to do the spell check.
        </p>
        {!spellcheckAdded && (
          <label className="flex items-center gap-2 mb-4 cursor-pointer">
            <input
              type="checkbox"
              checked={spellcheckConsent}
              onChange={(e) => setSpellcheckConsent(e.target.checked)}
              className="w-4 h-4 text-orange-500 border-gray-300 rounded focus:ring-orange-500"
            />
            <span className="text-gray-700 text-sm">I Agree for this step</span>
          </label>
        )}
        {spellcheckAdded ? (
          <>
            <p className="text-green-600 text-sm font-medium mb-3">
              Spellcheck Package added!
            </p>
            <button
              onClick={handleRemoveSpellcheck}
              className="bg-gray-900 text-white px-4 py-2 rounded-md hover:bg-gray-800 font-medium text-sm transition-colors"
            >
              Remove
            </button>
          </>
        ) : (
          <div className="flex gap-3">
            <button className="bg-white text-orange-500 px-4 py-2 rounded-md border border-orange-500 hover:bg-orange-50 font-medium text-sm transition-colors">
              Try Sample
            </button>
            <button
              disabled={!spellcheckConsent}
              onClick={handleAddSpellcheck}
              className="bg-gray-900 text-white px-4 py-2 rounded-md hover:bg-gray-800 font-medium text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              + Add Spellcheck Package
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SpellcheckSection;
